import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import SectionTitle from "../SectionTitle";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import TestimonialModal from "./TestimonialModal";
import { db } from "../../api/firebaseConfig";
import ts4 from "../../images/testimonial/4.webp";
import { collection, getDocs } from "firebase/firestore";

const Testimonial = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [desc, setDesc] = useState("");
  const [descOwner, setDescOwner] = useState("");
  const toggleModal = () => setShowModal(!showModal);
  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const snapshot = await getDocs(collection(db, "testimonials"));
      const newTestimonials = snapshot.docs.map(doc => {
        const data = doc.data();
        return {
          Des: `“${data.testimonial}”`,
          Title: data.name,
          Sub:data.riadOwner ? `Propriétaire de ${data.riadOwner}` : '',
          tsImg: ts4,
        };
      });
      setTestimonials(prev => [...prev, ...newTestimonials]);
    } catch (error) {
      console.error("Error fetching testimonials: ", error);
    }
  };

  const settings = {
    dots: false,
    arrows: false,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const showModalAdd = () => {
      const modal = new window.bootstrap.Modal(document.getElementById("testimonialModal"));
      modal.show();
    };
    const showModalTestimonial = () => {
      const modal = new window.bootstrap.Modal(document.getElementById("testimonialModalTestimonial"));
      modal.show();
    };

  return (
    <div className="wpo-testimonial-area section-padding">
      <div className="container">
        <SectionTitle subTitle={"Témoignages"} MainTitle={"Ce que nos clients disent"} />
        <div className="wpo-testimonial-wrap">
          <div className="testimonial-slider owl-carousel">
            <Slider {...settings}>
              {testimonials.map((tesmnl, index) => (
                <div className="wpo-testimonial-item" key={index}>
                  <div className="wpo-testimonial-top">
                    <div className="wpo-testimonial-img">
                      <img src={tesmnl.tsImg || "default-img.jpg"} alt="" />
                    </div>
                    <div className="wpo-testimonial-info">
                      <h2>{tesmnl.Title}</h2>
                      <span>{tesmnl.Sub}</span>
                    </div>
                  </div>
                  <div className="wpo-testimonial-content">
                    <p>
                      {tesmnl.Des.split(" ").slice(0, 30).join(" ") +
                        (tesmnl.Des.split(" ").length > 30 ? "..." : "")}
                      {tesmnl.Des.split(" ").length > 30 && (
                        <button
                          className="btn btn-link text-warning p-0"
                          onClick={()=> {setDescOwner(tesmnl.Title);setDesc(tesmnl.Des) ;toggleModal()}}
                          
                        >
                          Lire la suite
                        </button>
                      )}
                    </p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className="text-center btns mt-4">
          <button className="theme-btn" data-bs-toggle="modal" onClick={() => showModalAdd()} data-bs-target="#testimonialModal">
              Ajouter un Témoignage
            </button>
          </div>
        </div>
      </div>
      <TestimonialModal />



 {/* Bootstrap Modal */}
      <div
        className={`modal fade ${showModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background overlay
            position: "fixed", // Fixed position to stay on top of everything else
            top: "0", // Full height of the viewport
            left: "0", // Full width of the viewport
            right: "0",
            bottom: "0",
            zIndex: 9999, // Ensure it appears above other content
            width: "100%", // Optional: set to full width if needed
            height: "100%", // Optional: set to full height if needed
          }}
      >
        <div className="modal-dialog modal-lg" role="document" style={{
      position: "absolute", // Absolute positioning for centering
      top: "60%", // Vertically center the modal
      left: "50%", // Horizontally center the modal
      transform: "translate(-50%, -50%)", // Adjust for accurate centering
      zIndex: 1000, // Ensure modal content is above the overlay
      width: "80%", // Optional: set to full width if needed
      height: "100%", // Optional: set to full height if needed
      
    }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Témoignage de {descOwner}</h5>
              <button type="button" className="btn-close" onClick={toggleModal}></button>
            </div>
            <div className="modal-body">
              <p>{desc}</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Background Click to Close */}
      {showModal && <div className="modal-backdrop fade show" onClick={toggleModal}></div>}
    

    </div>
  );
};

export default Testimonial;
